import { createReducer, on } from '@ngrx/store';
import { RestrictionsProfileApiActions } from './restrictions-profile.actions';
import { initialState, adapter } from './restrictions-profile.state';

export const restrictionsProfileReducer = createReducer(
  initialState,
  on(RestrictionsProfileApiActions.profilesLoaded, (state, { profiles }) => adapter.upsertMany(profiles, state))
);

const { selectIds, selectEntities, selectAll } = adapter.getSelectors();

export const selectRestrictionsProfileIds = selectIds;
export const selectRestrictionsProfileEntities = selectEntities;
export const selectAllRestrictionsProfiles = selectAll;
